import loc from 'owa-localize';
import { SearchPlaceholder } from 'owa-locstrings/lib/strings/searchplaceholder.locstring.json';
import * as React from 'react';
import { logUsage } from 'owa-analytics';

const classNames = require('classnames');
const styles = require('./SearchInput.scss');

export default function SearchInputLoading(props: any): JSX.Element {
    const { isDisabled } = props;

    const searchInputClasses = classNames(
        styles.searchBoxInput,
        isDisabled && styles.isDisabled,
        styles.inputPlaceholder
    );

    const onClick = React.useCallback(() => {
        logUsage('Search_PlaceholderSearchBoxClicked');
    }, []);

    return (
        <div className={styles.searchBoxInputContainer} onClick={onClick}>
            <input
                className={searchInputClasses}
                disabled={true}
                placeholder={loc(SearchPlaceholder)}
            />
        </div>
    );
}
